module.exports = __webpack_public_path__ + "img/appAsset-brand--aeta.0d23189d.svg";